import { Box, Drawer as MUIDrawer, useMediaQuery, IconButton } from '@mui/material';
import { useDrawer } from '../../contexts/DrawerContext';
import { Header } from './Header';
import { List } from './List';
import CloseIcon from '@mui/icons-material/Close';

export const Drawer = () => {
	const { open, setOpen } = useDrawer();
	const isDesktop = useMediaQuery('(min-width:600px)'); // Adjust the breakpoint as per your design requirements
	return (
		<MUIDrawer
			open={open}
			onClose={() => setOpen(false)}
			anchor={isDesktop ? 'right' : 'bottom'}
			PaperProps={{
				sx: {
					width: isDesktop ? 'auto' : '100%',
					maxWidth: isDesktop ? '400px' : '100%',
					maxHeight: !isDesktop ? 'calc(100% - 56px)' : '100%',
					borderRadius: !isDesktop ? '16px 16px 0 0' : 0,
					overflowX: 'hidden',
				},
			}}
		>
			{' '}
			<Box
				sx={{
					p: { xs: 2, sm: 3, md: 4 },
					width: '100%',
					position: 'relative',
				}}
			>
				{!isDesktop && (
					<IconButton
						aria-label="close"
						onClick={() => setOpen(false)}
						sx={{
							position: 'absolute',
							right: 8,
							top: 8,
							color: (theme) => theme.palette.grey[500],
							zIndex: 1,
						}}
					>
						<CloseIcon />
					</IconButton>
				)}
				<Header />
				<List />
			</Box>
		</MUIDrawer>
	);
};
